// hooks/useMyActiveComplaints.js

import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { getCachedComplaints, subscribeToComplaintsCount } from '../services/complaintsCountService';

export const useMyActiveComplaints = () => {
    const { user } = useAuth();
    const [complaints, setComplaints] = useState([]);
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!user) {
            setComplaints([]);
            setCount(0);
            return;
        }

        const computeData = () => {
            const allComplaints = getCachedComplaints();
            // Filter: status === 'in-operation' AND assignedTo === user.uid
            const myActive = allComplaints.filter(
                (c) => c.status === 'in-operation' && c.assignedTo === user.uid
            );
            setComplaints(myActive);
            setCount(myActive.length);
        };

        // Compute immediately
        computeData();

        // Subscribe to updates – whenever the count cache changes, recompute
        const unsubscribe = subscribeToComplaintsCount(() => {
            computeData();
        });

        return () => unsubscribe();
    }, [user]);

    return { complaints, count };
};